// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__jOAbk","spin":"styles_spin__d7lRF"};